import { FlexLayout } from '@deity/falcon-ui';
import {
  EndpointActionButtons,
  FlowActionButtons,
  MappingActionButtons,
  PackageActionButtons,
  StructureActionButtons,
  WebServiceActionButtons
} from 'components';
import { CACHE_FIRST } from 'contracts/constants';
import type { FC } from 'react';
import { Route, useLocation, useRouteMatch } from 'react-router-dom';
import { useGetPackageVersionContentInfoQuery } from 'services/graphql/generated/hooks';
import { getParams } from 'utils';
import SubHeaderNavItem from './SubHeaderNavItem';
import { getNavItems, matchingPaths } from './nav-items';

interface SubHeaderProps {
  isEditable: boolean;
}
export const SubHeader: FC<SubHeaderProps> = ({ isEditable }) => {
  const { pathname } = useLocation();
  const { url } = useRouteMatch();
  // const [getPackage] = useGetPackageLazyQuery(CACHE_FIRST);
  // const [getPackageVersion] = useGetPackageVersionLazyQuery(CACHE_FIRST);
  // const { data } = useGetPackageVersionQuery(CACHE_FIRST);
  const { packageId, versionUuid } = getParams(pathname, matchingPaths) as any;
  const { data: versionContentData } = useGetPackageVersionContentInfoQuery({
    variables: { versionUuid },
    skip: !versionUuid,
    ...CACHE_FIRST
  });

  const routeWithButtons = [
    { path: 'package', element: <PackageActionButtons /> },
    { path: 'endpoints/:endpointId', element: <EndpointActionButtons isEditable={isEditable} /> },
    { path: 'services/:servicesId', element: <WebServiceActionButtons isEditable={isEditable} /> },
    { path: 'structures/:structureId', element: <StructureActionButtons isEditable={isEditable} /> },
    { path: 'mappings/editor/:mappingId', element: <MappingActionButtons isEditable={isEditable} /> },
    // { path: 'mappings/:mappingId', element: <MappingActionButtons isEditable={isEditable} /> },
    { path: 'flows/editor/:mappingId', element: <FlowActionButtons isEditable={isEditable} /> }
    // { path: 'flows/:flowId', element: <FlowActionButtons isEditable={isEditable} /> }
  ];

  const navigationItems = getNavItems(versionContentData?.getPackageVersionContentInfo);

  return (
    <FlexLayout
      bg="white"
      position="fixed"
      top={48}
      left={0}
      right={0}
      width="full"
      style={{ zIndex: 999, borderBottom: '1px solid #DADFE4', height: '55px' }}
      justifyContent="center"
      alignItems="center"
    >
      <div className="content">
        <FlexLayout justifyContent="space-between" alignItems="center">
          <nav style={{ display: 'flex', alignItems: 'center' }}>
            {navigationItems.map(navItem => (
              <SubHeaderNavItem key={navItem.to} {...navItem} />
            ))}
          </nav>

          <>
            {routeWithButtons.map(route => (
              <Route exact path={`${url}/${route.path}`} key={route.path}>
                {route.element}
              </Route>
            ))}
          </>
        </FlexLayout>
      </div>
    </FlexLayout>
  );
};
